import React, { Children, useEffect, useRef } from "react";
// import "./Modal.css";

export const ModalHeader = ({ title, close }) => {
  return (
    <div className="flex flex-row items-center border-b-2 pb-3">
      <div className="flex-1 text-center">
        <p className="text-xl font-bold">{title}</p>
      </div>
      <div className="ml-auto">
        <button className="text-2xl font-bold" onClick={() => close()}>
          &times;
        </button>
      </div>
    </div>
    // <div className="flex items-center border-b-2 pb-3">
    //   {/* Center the title */}
    //   <div className="flex-1 text-center">
    //     <p className="text-xl font-bold">{title}</p>
    //   </div>

    //   {/* Right-aligned "x" button */}
    //   <div className="ml-auto">
    //     <button className="text-2xl font-bold" onClick={() => close()}>
    //       &times;
    //     </button>
    //   </div>
    // </div>
  );
};

export const ModalBody = ({ children }) => {
  return <div>{children}</div>;
};

export const ModalFooter = ({ clickYes, clickNo }) => {
  return (
    <div className="mt-2 border-t-2 pt-2 flex flex-row justify-between items-start mx-2">
      <button
        className="px-3 py-2 bg-blue-500 text-white rounded-md"
        onClick={clickYes}
      >
        Submit
      </button>
      <button
        className="px-3 py-2 bg-gray-500 text-white rounded-md"
        onClick={clickNo}
      >
        Cancel
      </button>
    </div>
  );
};

export const Modal = ({ isOpen, close, children, width = "auto" }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      dialogRef.current.showModal();
    } else {
      dialogRef.current.close();
    }
  }, [isOpen]);

  const handleClickOutside = (event) => {
    if (event.target === dialogRef.current) {
      close();
    }
  };

  return (
    <div>
      {/* {isOpen && <div className="modal-backdrop" onClick={close}></div>} */}

      <dialog
        ref={dialogRef}
        onClick={handleClickOutside}
        className={`p-3 border border-black rounded-2xl ${width}`}
      >
        {children}
      </dialog>
    </div>
  );
};
